import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_PINNED_UNIT = (unitId: string) => ['getDashPinnedUnit', unitId]

export const getDashPinnedUnit = async (unitId: string): Promise<{ isPinned: boolean; data: IPortalUnitSearchModel }> =>
  axios.get(`/dashwidget/getpinnedunit?unitId=${unitId}`).then((res) => ({
    isPinned: res.data?.data != null,
    data: res.data?.data
  }))

type QueryFnType = typeof getDashPinnedUnit

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetDashPinnedUnit = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0, retry: 0 },
    queryKey: QUERY_KEY_GET_PINNED_UNIT(unitId),
    queryFn: () => getDashPinnedUnit(unitId)
  })
